module.exports = __webpack_public_path__ + "static/media/instapage11.92bb8c5e.png";